<template>
  <div id="match">
    <!-- {{ match }} -->

    <div class="meta">
      <div class="category">
        {{'miclive.standing.category' | translate}} {{ $store.getters['competition/get_category_by_id']( match.category_id ).name }} - {{'miclive.standing.group' | translate}}
        {{ $store.getters['competition/get_group_by_id']( $route.params.group ).name }}
      </div>
      <div class="place"><span class="city">{{ $store.getters['competition/get_facility_by_id']( match.facility_id ).city }}</span><span class="name">{{ $store.getters['competition/get_facility_by_id']( match.facility_id ).name }}</span></div>
      <div class="date">{{ match.date | date }}</div>
      <div v-if="match.streaming" class="streaming"></div>
    </div>
    <div class="content">
      <table>
        <tr>
          <td class="shield"><img :src="match.teams.local_team.shield" /></td>
          <td class="name tleft">{{ match.teams.local_team.name }}</td>
          <td class="result">
            <!-- {{ match.resume.local }} - {{ match.resume.away }} -->
            0 - 0
          </td>
          <td class="name tright">{{ match.teams.away_team.name }}</td>
          <td class="shield"><img :src="match.teams.away_team.shield" /></td>
        </tr>
      </table>
    </div>
    <!-- <div v-if="match.info.start" class="actions" @click="expand()">
      <template v-if="expanded">{{'miclive.standing.show-less' | translate}}</template>
      <template v-else>{{'miclive.standing.show-more' | translate}}</template>
    </div> -->

    <!-- <template v-if="expanded">
      <div class="selector">
        <div class="item" :class="{ selected: option == 1 }" @click="select(1)">
          {{'miclive.standing.alignments' | translate}}
        </div>
        <div class="item" :class="{ selected: option == 2 }" @click="select(2)">
          {{'miclive.standing.match' | translate}}
        </div>
      </div>

      <table v-if="option == 1" class="lineup">
        <tr>
          <td class="team local">
            <div class="list">
              <div class="title starters">{{'miclive.standing.holders' | translate}}</div>
              <div v-for="(player, index) in match.teams[0].players" v-if="player.starter" class="item">
                <span class="number">{{ player.number }}</span><span class="name">{{ player.name }}</span>
              </div>
            </div>
            <div class="list bench">
              <div class="title">{{'miclive.standing.substitutes' | translate}}</div>
              <div v-for="(player, index) in match.teams[0].players" v-if="!player.starter" class="item">
                <span class="number">{{ player.number }}</span><span class="name">{{ player.name }}</span>
              </div>
            </div>
          </td>
          <td class="separator"></td>
          <td class="team away">
            <div class="list">
              <div class="title starters">{{'miclive.standing.holders' | translate}}</div>
              <div v-for="(player, index) in match.teams[1].players" v-if="player.starter" class="item">
                <span class="number">{{ player.number }}</span><span class="name">{{ player.name }}</span>
              </div>
            </div>
            <div class="list bench">
              <div class="title">{{'miclive.standing.substitutes' | translate}}</div>
              <div v-for="(player, index) in match.teams[1].players" v-if="!player.starter" class="item">
                <span class="number">{{ player.number }}</span><span class="name">{{ player.name }}</span>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <table v-if="option == 2" class="summary">
        <tr>
          <td class="team local">
            <div class="events">
              <div v-for="(event, index) in events_local" class="item">
                <span class="time">{{ event.data.time }}'</span>
                <span class="type" :class="'t_' + event.type"></span>
                <span class="player">{{
                  match.teams[0].players[event.data.player].name
                }}</span>
              </div>
            </div>
          </td>
          <td class="separator"></td>
          <td class="team away">
            <div class="events">
              <div v-for="(event, index) in events_away" class="item">
                <span class="player">{{
                  match.teams[0].players[event.data.player].name
                }}</span>
                <span class="type" :class="'t_' + event.type"></span>
                <span class="time">{{ event.data.time }}'</span>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </template> -->
  </div>
</template>

<script>
  export default {
    name: "Match",
    props: {
      id: String
    },
    data() {
      return {
        expanded: false,
        option: 1
      };
    },
    computed: {
      match() {
          return this.$store.getters['competition/get_match_by_id']( this.id )
      },

      events_local() {
        let events = [];
        for (var key in this.match.log.events) {
          let event = this.match.log.events[key];
          if (["goal", "yellow", "red"].includes(event.type)) {
            if (event.data.team == 1) {
              events.push(event);
            }
          }
        }
        return events;
      },
      events_away() {
        let events = [];
        for (var key in this.match.log.events) {
          let event = this.match.log.events[key];
          if (["goal", "yellow", "red"].includes(event.type)) {
            if (event.data.team == 2) {
              events.push(event);
            }
          }
        }
        return events;
      }
    },
    methods: {
      load() {},
      expand() {
        this.expanded = !this.expanded;
      },
      select(value) {
        this.option = value;
      }
    },
    created() {
      this.load();
    }
  };

</script>

<style lang="scss" scoped>
  #match {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    border-bottom: 2px solid #eee;
    padding: 15px;
    margin-bottom: 50px;

    .meta {
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        margin: 0 auto;
        padding: 5px 25px;
        border-radius: 15px;
        text-transform: uppercase;
        color: #7b7777;
        overflow: hidden;
        background-color: #d6cece;

      .category {
        display: inline-block;
      }

      .date {
        display: inline-block;
        margin: 0 10px;
        //   font-family: AvantGarde;
        line-height: 30px;
      }

      .place {
        display: inline-grid;
        margin: 0 15px;

        // &:after,
        // &:before {
        //   content: "|";
        //   padding: 0 15px;
        //   color: #ddd;
        // }
        .city {
            display: block;
        }
        .name {
            display: block;
            font-size: 12px;
        }
      }

      .streaming {
        display: inline-block;
        background: url("/img/streaming.png") no-repeat center center;
        width: 50px;
        background-size: 50px;
        height: 27px;
        /* margin-top: 5px; */
        float: right;
        margin-left: 10px;
      }
    }

    .content {
      table {
        width: 100%;

        td {
          text-align: center;
        }
      }

      .shield {
        width: 100px;

        img {
          height: 60px;
        }
      }

      .name {
        width: calc(100% - 350px);
        width: 30%;

        &.tleft {
          text-align: right;
        }

        &.tright {
          text-align: left;
        }
      }

      .result {
        width: 250px;
        font-family: AvantGarde;
        color: $main-color;
        font-size: 30px;
      }
    }

    .actions {
      cursor: pointer;
      color: #999;
      text-decoration: underline;
      font-size: 12px;
    }

    .selector {
      margin-bottom: 20px;

      .item {
        padding: 5px 15px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        margin-bottom: 5px;
        margin-top: 15px;
        font-size: 14px;

        &.selected {
          border-bottom: 5px solid $main-color !important;
          font-family: AvantGarde;
        }

        &:hover {
          border-bottom: 5px solid #ddd;
        }
      }
    }

    .lineup {
      table-layout: fixed;
      background-color: #f7f7f7;
      padding: 20px;
      border-radius: 5px;

      .team {
        width: 400px;
        vertical-align: top;
        text-align: left;

        .list {
          .title {
            font-family: AvantGarde !important;
            font-size: 16px !important;
            text-transform: uppercase;
            margin-bottom: 15px;
          }

          .item {
            .number {
              font-family: AvantGarde;
              width: 20px;
              display: inline-block;
            }

            .name {
              display: inline-block;
              margin-left: 10px;
              text-transform: uppercase;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }

          &.bench {
            margin-top: 20px;
          }
        }

        &.away {
          .list {
            text-align: right;

            .item {
              .number {
                float: right;
                margin-left: 10px;
              }
            }
          }
        }
      }

      .separator {
        width: 250px;
      }
    }

    .summary {
      table-layout: fixed;
      background-color: #f7f7f7;
      padding: 20px;
      border-radius: 5px;

      .team {
        width: 400px;
        vertical-align: top;
        text-align: left;

        .events {
          .item {
            padding: 10px 0;

            .time {
              font-family: AvantGarde;
              width: 20px;
              display: inline-block;
            }

            .type {
              width: 20px;
              height: 20px;
              display: inline-block;
              margin: 0 10px;
              background-position: center;
              background-size: 20px;
              background-repeat: no-repeat;
              float: left;

              &.t_goal {
                background-image: url("/img/events/goal.svg");
              }

              &.t_yellow {
                background-image: url("/img/events/card_yellow.svg");
              }

              &.t_red {
                background-image: url("/img/events/card_red.svg");
              }
            }

            .player {
              display: inline-block;
              margin-left: 10px;
              text-transform: uppercase;
            }
          }
        }

        &.away {
          text-align: right;

          .events {
            .item {
              .type {
                float: right;
              }

              .time {
                margin-left: 10px;
              }
            }
          }
        }
      }

      .separator {
        width: 250px;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    #match {
      padding: 5px;

      .meta {
        padding: 5px 5px;
        border-radius: 5px;
        font-size: 10px;
        text-align: center;

        .category {}

        .date {
          margin: 0 5px;
        }

        .place {

          &:after,
          &:before {
            padding: 0 5px;
          }
        }

        .streaming {
          width: 40px;
          background-size: 40px;
          margin-left: 0px;
        }
      }

      .content {
        .shield {
          width: 40px;

          img {
            height: 35px;
          }
        }

        .name {
          font-size: 12px;
          width: 25%;
        }

        .result {
          width: 250px;
          font-size: 20px;
        }
      }

      .actions {}

      .selector {
        .item {
          font-size: 12px;

          &.selected {
            border-bottom: 3px solid $main-color !important;
            font-family: AvantGarde;
          }

          &:hover {
            border-bottom: 3px solid #ddd;
          }
        }
      }

      .lineup {
        padding: 5px;

        .team {
          width: 400px;

          .list {
            .title {
              font-size: 14px !important;
            }

            .item {
              .number {
                width: 15px;
                font-size: 12px;
              }

              .name {
                font-size: 12px;
              }
            }

            &.bench {
              margin-top: 40px;
            }
          }

          &.away {
            .list {
              text-align: right;

              .item {
                .number {
                  float: right;
                  margin-left: 10px;
                }
              }
            }
          }
        }

        .separator {
          width: 25px;
        }
      }

      .summary {
        padding: 5px;

        .team {
          width: 400px;
          vertical-align: top;
          text-align: left;

          .events {
            .item {
              padding: 5px 0;

              .time {
                width: 15px;
                font-size: 12px;
              }

              .type {
                width: 15px;
                height: 15px;
                margin: 0 5px;
                background-size: 15px;
              }

              .player {
                font-size: 12px;
                margin-left: 10px;
              }
            }
          }

          &.away {
            text-align: right;

            .events {
              .item {
                .type {
                  float: right;
                }

                .time {
                  margin-left: 10px;
                }
              }
            }
          }
        }

        .separator {
          width: 25px;
        }
      }
    }
  }

</style>
